import { useSelector } from "react-redux";
import {
  onDragStart, onDragEnd, onDragEnter, onDragLeave,
  statusColorRenderer,
} from "../../util/helper/helperFunctions";
import "../../assets/css/Status/status.css";

const labelMap = (key) => {
  if (key === "Wait Qty Check") return "Wait Quantity Check";
  if (key === "Wait Dock Cnfrm") return "Wait Dock Confirm";
  if (key === "Wait Start Cnfrm") return "Wait Start Confirm";
  return key;
};

const ShipmentStatus = ({ scrollable, socket }) => {
  const { loading, data } = useSelector(
    (state) => state.dashboard.shipmentStatus
  );

  return (
    <div
      draggable
      onMouseDown={(event) => onDragStart(event)}
      onMouseUp={(event) => onDragEnd(event)}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      className="status-container"
    >
      <div className="header-section">
        <h4>Shipment Status</h4>
      </div>
      {data.length === 0 ? (
        <div
          className={`status-section loader-alignment ${
            scrollable ? "status-section-wrap" : ""
          } `}
        >
          {loading ? (
            <div className="rm-loader">
              <h4>Loading...</h4>
              <div className="spinner"></div>
            </div>
          ) : (
            <h4>No data available!</h4>
          )}
        </div>
      ) : (
        <div
          className={`status-section ${
            scrollable ? "status-section-wrap" : ""
          }`}
        >
          {data?.map((status, index) => {
            const [key, value] = Object.entries(status)[0];
            return (
              <div
                key={index}
                style={{
                  boxShadow: `0 6px 12px 0 ${statusColorRenderer(key)}20`,
                }}
                className="status-box"
              >
                <div
                  style={{
                    backgroundColor: statusColorRenderer(key),
                  }}
                  className="status-top-section"
                >
                  <p>{labelMap(key)}</p>
                </div>
                <div className="status-bottom-section">
                  <p>{value}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ShipmentStatus;
